import { makeStyles } from '@material-ui/core';
import CashierPreferencesHelper from 'src/common/helpers/cashier-preferences-helper';
import { calculateHeight, calculateWidth } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export interface Props {
  operational?: boolean;
  selected?: boolean;
}

export const useStyles = makeStyles(() => ({
  root: {
    margin: `0 0 ${calculateHeight(16).stringValue}`,
    border: ({ selected }: Props) =>
      selected ? `3px solid ${themeColor.alert}` : `1px solid ${themeColor.secondaryLight}`,
    padding: '0',
    '&:hover': {
      backgroundColor: themeColor.white,
    },
    '&:last-of-type': {
      marginBottom: 0,
    },
    pointerEvents: ({ operational }: Props) => (operational ? 'none' : 'all'),
  },
  icon: {
    flexShrink: 0,
    padding: `0 ${calculateWidth(15).stringValue}`,
    height: CashierPreferencesHelper.textSizeScalar() * 24,
    width: CashierPreferencesHelper.textSizeScalar() * 24,
  },
  label: {
    color: ({ operational }: Props) =>
      operational ? themeColor.palesky : themeColor.defaultTextColor,
  },
}));
